import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'

import { showAppLoader, hideAppLoader } from '../app';
// import _ from 'lodash';

export const fetchManageAccountDataApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/v2/get_manage_account_details', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const certificateList = (token, authId) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/tax/certificate_list?id=' + authId, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const getProfile = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/profile', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const getProfileDetails = (token, data) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post(`user/v2/internal/user_profile`, data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};
export const getGenToken = (token, authId) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/order/tax/get_ecomm_token?id=' + authId, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const editProfile = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/profile/edit', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const profileImage = (formData, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/profile-image', formData, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const imageShow = (imgName, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/image/' + imgName, '', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const taxExemptionApi = (formData, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/tax-exemption', formData, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const deleteTaxExemptionApi = (state, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get(`/user/tax-exemption/delete/${state}`, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};
export const taxExemptFileDownload = (token, urlPath) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get(urlPath, {
      headers: {
        Authorization: `${token}`,
        'Content-Type': "application/octet-stream"
      },
      responseType: 'blob',
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      return ex;
    });
};